/* eslint-disable no-template-curly-in-string */
import createRouterBuilder from 'router-segments/src';
import type { SegmentRouterBuilderType } from 'router-segments/src/types';
import homeController from './modules/home/homeController';
import screenController from './modules/api/screenController';
import displayController from './modules/api/displayController';

export default () => {
  const builder = createRouterBuilder();
  builder.add('/', homeController.index);
  // builder.add('/noconfig', );
  builder.addSegment('/api', (segment: SegmentRouterBuilderType) => {
    segment.add('/screen', screenController.index);
    segment.addSegment('/display', (segment: SegmentRouterBuilderType) => {
      segment.defaultRoute(displayController.index);
      segment.add('/start', displayController.start);
      segment.add('/restart', displayController.restart);
      segment.add('/stop', displayController.stop);
      segment.add('/refresh', displayController.refresh);
      segment.add('/openboxStarted', displayController.openboxStarted);
    });
  });
  return builder.createRouter();
};
